module.exports = __webpack_public_path__ + "static/media/JustActMailers_10-01.2680ec7c.jpg";